// Locale + currency helpers
import { useEffect, useState } from "react";
import { api } from "./api";

const SYMBOLS = {
  USD: "$", EUR: "€", GBP: "£", INR: "₹", JPY: "¥", AUD: "A$", CAD: "C$",
  SGD: "S$", AED: "د.إ", HKD: "HK$", CHF: "CHF", CNY: "¥", KRW: "₩",
  NZD: "NZ$", ZAR: "R", BRL: "R$", MXN: "MX$", RUB: "₽", SAR: "﷼",
  IDR: "Rp", MYR: "RM", THB: "฿", TRY: "₺", PHP: "₱", VND: "₫",
};

export const currencySymbol = (code) => SYMBOLS[code] || (code ? code + " " : "");

export const formatPrice = (price, currency) => {
  if (price === null || price === undefined || price === "") return "Best Offer";
  const sym = currencySymbol(currency);
  try {
    return `${sym}${Number(price).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
  } catch {
    return `${sym}${price}`;
  }
};

const KEY = "pbp:geo";

export const useGeo = () => {
  const [geo, setGeo] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (geo?.country_code) return;
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get("/geo/lookup");
        if (!cancelled && r.data) {
          setGeo(r.data);
          localStorage.setItem(KEY, JSON.stringify(r.data));
        }
      } catch {}
    })();
    return () => {
      cancelled = true;
    };
  }, [geo]);

  return geo || { country: "India", country_code: "IN", currency: "INR" };
};

export const distanceLabel = (km, country_code) => {
  if (km === null || km === undefined) return "";
  // miles for US/UK
  if (country_code === "US" || country_code === "GB") {
    const mi = km * 0.621371;
    return `${mi < 10 ? mi.toFixed(1) : Math.round(mi)} mi away`;
  }
  return `${km < 10 ? km.toFixed(1) : Math.round(km)} km away`;
};
